/* Rescuevation - VR-Ausbildung Premium (vkp-Sections)

   1. Einmal-Folgen: [data-vkp-live] bekommt beim ersten Sichtkontakt .is-live,
      danach trennt sich der Observer. Der Ruhezustand ohne Klasse ist das
      fertige Bild (additive Bewegung), ohne JS bleibt alles sichtbar.
   2. Loops (.vkp-loop) pausieren, solange ihre Section nicht im Bild ist.
   3. prefers-reduced-motion: Video pausiert, keine Zaehler, keine Klassen.
   4. Zaehler: [data-vkp-zahl] mit reiner Ganzzahl zaehlt einmal hoch, der
      Endwert steht im DOM.
   5. Kauf: form[data-vkp-kauf] legt per cart/add.js in die Schublade
      (Muster aus rescu-vrk-c-matrix), Fallback ist der normale POST.
   6. Anliegen-Chip im Formular blitzt nach einem Sprung einmal kurz auf.
      Die Vorwahl selbst setzt rescu-vrk-anfrage.liquid. */
(function () {
  if (window.__vkpPremium) return;
  window.__vkpPremium = true;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;

  function start() {
    var buehnen = document.querySelectorAll('[data-vkp-buehne]');
    var live = document.querySelectorAll('[data-vkp-live]');

    /* 3. Video bei reduzierter Bewegung anhalten */
    if (ruhig) {
      buehnen.forEach(function (b) {
        var v = b.querySelector('video');
        if (v) {
          v.removeAttribute('autoplay');
          try { v.pause(); } catch (e) {}
        }
      });
    }

    if (!hatIO) return;

    /* 1. Einmal-Folgen */
    if (!ruhig) {
      var einmal = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-live');
          zaehle(e.target);
          einmal.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });
      live.forEach(function (el) { einmal.observe(el); });
    }

    /* 2. Loops und Video ausserhalb des Viewports pausieren */
    var sicht = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        e.target.classList.toggle('vkp-pausiert', !e.isIntersecting);
        var v = e.target.matches('[data-vkp-buehne]') ? e.target.querySelector('video') : null;
        if (v && !ruhig) {
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        }
      });
    }, { threshold: 0 });
    buehnen.forEach(function (el) { sicht.observe(el); });
    live.forEach(function (el) { sicht.observe(el); });
  }

  /* 4. Zaehler */
  function zaehle(wurzel) {
    var felder = wurzel.querySelectorAll('[data-vkp-zahl]');
    felder.forEach(function (f) {
      var ende = f.textContent.trim();
      var m = ende.match(/^(\d{1,4})(\s?%)?$/);
      if (!m) return;
      var ziel = parseInt(m[1], 10);
      var rest = m[2] || '';
      if (ziel < 2) return;
      f.setAttribute('aria-label', ende);
      var t0 = null;
      var dauer = 1100;
      function schritt(t) {
        if (!t0) t0 = t;
        var x = Math.min(1, (t - t0) / dauer);
        var k = 1 - Math.pow(2, -10 * x);
        f.textContent = Math.round(ziel * k) + rest;
        if (x < 1) {
          requestAnimationFrame(schritt);
        } else {
          f.textContent = ende;
          f.removeAttribute('aria-label');
        }
      }
      requestAnimationFrame(schritt);
    });
  }

  /* 5. Kauf per AJAX in die Schublade */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-vkp-kauf]') : null;
    if (!form || !window.fetch) return;
    var feld = form.querySelector('input[name="id"]');
    var id = feld ? parseInt(feld.value, 10) : 0;
    if (!id) return;
    e.preventDefault();
    if (form.__vkpLaeuft) return;
    form.__vkpLaeuft = true;

    var btn = form.querySelector('button[type="submit"]');
    var text = btn ? btn.querySelector('.vkp-btn__text') : null;
    if (btn) {
      if (text && !btn.__vkpLabel) btn.__vkpLabel = text.textContent;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-laedt');
      if (text) text.textContent = 'Wird hinzugefügt …';
    }
    var schublade = document.querySelector('cart-drawer');
    /* Fokus nach dem Schliessen der Schublade an den Kauf-Button zurueckgeben (wie Dawns product-form.js) */
    if (schublade && typeof schublade.setActiveElement === 'function' && btn) schublade.setActiveElement(btn);
    var body = { items: [{ id: id, quantity: 1 }] };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (daten) {
          if (!res.ok || daten.status) throw new Error(daten.description || 'HTTP ' + res.status);
          return daten;
        });
      })
      .then(function (daten) {
        if (!(schublade && typeof schublade.renderContents === 'function' && daten.sections)) {
          window.location.href = root + 'cart';
          return;
        }
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-laedt');
          btn.classList.add('is-drin');
          if (text) text.textContent = 'Im Warenkorb';
        }
        setTimeout(function () {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        }, 350);
        setTimeout(function () {
          if (!btn) return;
          btn.classList.remove('is-drin');
          if (text && btn.__vkpLabel) text.textContent = btn.__vkpLabel;
          btn.removeAttribute('aria-disabled');
          form.__vkpLaeuft = false;
        }, 2400);
      })
      .catch(function () {
        form.removeAttribute('data-vkp-kauf');
        form.submit();
      });
  });

  /* 6. Vorgewaehlten Anliegen-Chip kurz aufblitzen lassen */
  document.addEventListener('click', function (e) {
    var ausloeser = e.target.closest ? e.target.closest('[data-vrk-anliegen]') : null;
    if (!ausloeser || ruhig) return;
    setTimeout(function () {
      var feld = document.querySelector('#ContactForm input[name="contact[Anliegen]"]:checked');
      var chip = feld ? feld.closest('label') : null;
      if (!chip) return;
      chip.classList.remove('vkp-blitz');
      void chip.offsetWidth;
      chip.classList.add('vkp-blitz');
      setTimeout(function () { chip.classList.remove('vkp-blitz'); }, 700);
    }, 450);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
